import React, {
  Component
} from 'react'
import {
  NavBar,
  List,
  SearchBar,
  Toast
} from 'antd-mobile'
import {
  ROOT_PATH
} from '../../config';
import axios from 'axios'
import Table from '../../components/Table'
import qs from 'qs';
import df from 'dateformat'
import {FARM_ORG, ORG_CODE, TOKEN} from '../../cache';
let TYPES = {
  'A': '返情/空怀',
  'D': '死亡',
  'F': '分娩',
  'G': '后备猪',
  'M': '配种',
  'TIN': '转入',
  'V': '选种',
  'W': '断奶'
}
export default class NpDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [
        {
          id: 'col1',
          title: '名称', //表头信息
          fixed: true, //是否为固定表头
          width: 40, //设置固定宽度
          align: 'left', //文本对齐方式 left center right
          //定制该列数据的显示格式
          render(data, index) {
            return <span style={{ color: '#888' }}>{1+index}</span>
          }
        },
        {
          id: 'col2',
          title: '耳号',
          width: 155,
          align: 'right'
        },
        {
          id: 'col3',
          title: '胎次',
          width: 60,
          align: 'right'
        },
        {
          id: 'col4',
          title: '状态日期',
          width: 180,
          align: 'right'
        },
        {
          id: 'col5',
          title: '上次状态',
          width: 150,
          align: 'right'
        },
        {
          id: 'col6',
          title: '天数',
          width: 60,
          align: 'right'
        }
      ],
      details: [
      ],
      details1: [],  // 筛选后结果
      datas: []    // 原结果
    }
  }
  getDetail = (obj) => {
    Toast.loading('加载中');
    axios.post(
      `${ROOT_PATH}/api/forward/ifarm/status-pig`,
      qs.stringify(
        {
          startDate: df(this.props.date,'yyyy-mm-dd'),
          endDate: df(this.props.date,'yyyy-mm-dd'),
          dateToday: df(this.props.date,'yyyy-mm-dd'),
          gd_type: obj.gdType,
          gd_code: obj.gdCode
        }
      ),
      {
        headers: {
          'x-http-appid': '1',
          'x-http-device': '0',
          'Content-Type':'application/x-www-form-urlencoded',
          'Authorization': TOKEN,
          'farmorg': FARM_ORG,
          'orgcode': ORG_CODE
        }
      }
    )
      .then((res) => {
        Toast.hide();
        let datas = [];
        res.data.map((item,index) => {
          let activityType = item.activityTypeDate.split(' ')[0];
          let activityDate = item.activityTypeDate.split(' ')[1];
          let lastActivityType = item.lastActivityTypeDate.split(' ')[0];
          let lastActivityDate = item.lastActivityTypeDate.split(' ')[1];
          datas.push({
            col1: index,
            col2: item.swineTrack,
            col3: item.parity,
            col4: `${activityType && TYPES[activityType]} ${activityDate}`,
            col5: `${lastActivityType && TYPES[lastActivityType]} ${lastActivityDate}`,
            col6: item.days
          })
        });
        this.setState({details: datas, datas})
      })
      .catch((err) => {return err})
  };
  componentDidMount() {
    this.getDetail(this.props.data);
  }
  search = (v) => {
    const details = this.state.datas.filter((obj) => {
      let swineId = obj.col2.split('-')[3];
      return swineId.indexOf(v || '') >=0
    })
    this.setState({
      details
    })
  }
  render() {
    const propsData = this.props.data;
    return (
      <React.Fragment>
        <NavBar mode="light">{propsData.descLoc}</NavBar>
        <SearchBar
          onChange={this.search.bind(this)}
          placeholder="搜索"
      />
        <List style={{height: document.documentElement.clientHeight - 90,overflowY: 'scroll'}}>
          {/*<List.Item >{propsData.descLoc}</List.Item>*/}
          <Table columns={this.state.columns}
              data={this.state.details}
          />
        </List>

      </React.Fragment>
    )
  }
}
